import { useI18n } from "vue-i18n"

export function getCurrentLocale(): string {
  const { locale } = useI18n()
  return locale.value
}

export function normalizeString(str: string | null): string | null {
  if (str == null) return null
  return str == null || str === "" ? "-" : str
}

export function formatByNumber(str: string, ...args: any[]): string {
  return str.replace(/#(\d+)#/g, (_, i) => (typeof args[i] !== "undefined" ? args[i] : `#${i}#`))
}

export function formatByName(str: string, values: any[]): string {
  return str.replace(/#(\w+)#/g, (_, key) => (key in values ? values[key] : `#${key}#`))
}

export function formattedNumber(value: number | null): string | null {
  if (value == null) return null
  if (typeof value === "string") value = Number.parseFloat(value)
  return Number.isInteger(value)
    ? value.toLocaleString("en-US")
    : value.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
}

export function unitedNumber(value: number | null, unit: string | null): string | null {
  if (value == null) return null
  const formatted = formattedNumber(value)
  return formatted + " " + unit
}

export function formattedDate(isoString: string | Date | null, includeYear = true): string {
  if (isoString == null) return "-"

  const d = new Date(isoString)
  const options = {
    month: "short",
    day: "numeric",
  } as Intl.DateTimeFormatOptions

  if (includeYear) options.year = "numeric"
  return new Intl.DateTimeFormat(getCurrentLocale(), options).format(d)
}

export function formattedTime(isoString: string | Date | null): string {
  if (isoString == null) return "-"

  const d = new Date(isoString)
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(d)
}

export function formatLocalDate(d: Date, includeYear = true): string {
  const options = {
    month: "short",
    day: "numeric",
  } as Intl.DateTimeFormatOptions
  if (includeYear) options.year = "numeric"
  return new Intl.DateTimeFormat(getCurrentLocale(), options).format(d)
}

export function simpleFormatLocalDate(d: Date): string {
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, "0") // months are 0-indexed
  const dd = String(d.getDate()).padStart(2, "0")
  return `${yyyy}-${mm}-${dd}`
}
